
/* global process */
/* jshint strict:false */
define('wrap',['require'],function (require) {
    // Not using strict mode because Firefox applies strict mode to the eval'd code, which is not always strict mode compliant. Note that
    // this does only apply to non-optimized RequireJS code.
    //'use strict';

    //>>excludeStart('excludeWrap', pragmas.excludeWrap)

    var fs,
        fetchText = function () {
            throw 'Not implemented in this environment';
        },
        contentMap = {};

    // file fetching stuff
    if (typeof window !== 'undefined' && window.navigator && window.document && !window.navigator.userAgent.match(/Node.js/)) {
        // Browser action
        fetchText = function (url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function (evt) {
                //Do not explicitly handle errors, those should be
                //visible via console output in the browser.
                if (xhr.readyState === 4) {
                    callback(xhr.responseText);
                }
            };
            xhr.send(null);
        };

    } else if (typeof process !== 'undefined' &&
        process.versions &&
        !!process.versions.node) {
        //Using special require.nodeRequire, something added by r.js.
        fs = requirejs.nodeRequire('fs');
        fetchText = function (path, callback) {
            var body = fs.readFileSync(path, 'utf8') || '';
            // we need to remove BOM stuff from the file content
            body = body.replace(/^\uFEFF/, '');
            callback(body);
        };
    }


    // parsed configuration for each wrapped module
    var getWrapConfig = (function () {
        var wrapConfig = null;

        return function (requireConfig) {
            if (wrapConfig) return wrapConfig;

            var rComma = /\s*,\s*/;

            function parseModuleConfig(rawConfig, moduleName) {
                var split = rawConfig.deps.split('->');
                if (split.length !== 2) {
                    throw new Error('Invalid wrap config for "' + moduleName + '": `deps` string must contain one "->"');
                }

                var exports = split[1] ? split[1].trim().split(rComma) : [],
                    // by default, export first listed global (account for aliases, picking the first)
                    moduleValueKey = exports[0] ? exports[0].split('|')[0] : null;

                return {
                    deps: split[0] ? split[0].trim().split(rComma) : [],
                    exports: exports,
                    init: rawConfig.init ? rawConfig.init.toString() : moduleValueKey ? 'function () { return this["' + moduleValueKey + '"];}' : 'function () {return void 0;}',
                    // Raw JS to execute before the module content. This setting should rarely be used, but adds some flexibility without overly complicating this module
                    pre: rawConfig.pre || '',
                    post: rawConfig.post || ''
                };
            }

            function parseSection(section) {
                var parsedSection = {};
                for (var moduleName in section) {
                    if (section.hasOwnProperty(moduleName)) {

                        var rawConfig = section[moduleName],
                            config;
                        if (typeof rawConfig === 'string') {
                            // only deps string
                            config = parseModuleConfig({ deps: rawConfig }, moduleName);
                        } else if (rawConfig && typeof rawConfig === 'object') {
                            // must have `deps` property
                            if (!rawConfig.deps) throw 'Wrap config must have "deps" property.';

                            config = parseModuleConfig(rawConfig, moduleName);
                        } else {
                            throw new Error('Invalid wrap module config.');
                        }
                        parsedSection[moduleName] = config;
                    }
                }
                return parsedSection;
            }

            wrapConfig = {
                configs: parseSection(requireConfig.wrapped.configs),
                pseudoConfigs: parseSection(requireConfig.wrapped.pseudoConfigs)
            };
            return wrapConfig;
        };
    }());

    // mapping of wrapped module path to module name
    var getModulePathToNameMap = (function () {
        var wrapMapping = null;
        return function (requireConfig) {
            if (wrapMapping) return wrapMapping;

            // look in config `map` section to get module names mapping to wrapped source paths
            wrapMapping = {};
            var rWrappedModuleName = /^wrap!(.*)/;
            // currently only located in the '*' portion. update if this changes
            var mapSection = requireConfig.map['*'];
            for (var moduleName in mapSection) {
                if (mapSection.hasOwnProperty(moduleName)) {
                    var wrappedName = (rWrappedModuleName.exec(mapSection[moduleName]) || [])[1];
                    if (wrappedName) {
                        wrapMapping[wrappedName] = moduleName;
                    }

                }
            }

            return wrapMapping;
        };
    }());

    function wrapModule(moduleCode, depModuleToGlobalMap, globalExports, initFunction, isBuild, fullModulePath) {
        // required modules
        var depModules = [],
            // parameter name for the module's value; matches the name of the exported global, if present
            depGlobals = [];


        function addGlobal(g) {
            depModules.push(depModuleName);
            depGlobals.push(g);
        }

        // flatten map to pair of arrays, listing 
        for (var depModuleName in depModuleToGlobalMap) {
            if (depModuleToGlobalMap.hasOwnProperty(depModuleName)) {
                var global = depModuleToGlobalMap[depModuleName];
                if (!global) {
                    // create stub unused variable that acts purely as a placeholder
                    global = '_undefined' + depModules.length;
                }

                global.split('|').forEach(addGlobal);
            }
        }

        var substitutions = {
            // prevent duplicate anonymouse define calls causing build warnings
            'DEFINE': 'define',
            '[DEPENDENCY_NAMES]': JSON.stringify(depModules),
            'DEPENDENCY_ARGUMENTS': depGlobals.join(', '),
            '[DEPENDENCY_ARGUMENTS_LIST]': JSON.stringify(depGlobals),
            '[DECLARED_GLOBALS_LIST]': JSON.stringify(globalExports),
            'INIT_FUNCTION': initFunction,
            // during the build, window is undefined, but it gets evaluated
            'WINDOW': isBuild ? 'this' : 'window',
            // listing last so it should it should be substituted last
            'MODULE_CODE();': '\n' + moduleCode
        };

        // ReSharper disable UseOfImplicitGlobalInFunctionScope
        /* global DEFINE, DEPENDENCY_NAMES, DEPENDENCY_ARGUMENTS_LIST, DECLARED_GLOBALS_LIST, MODULE_CODE, INIT_FUNCTION, WINDOW */
        function moduleDefinitionTemplate() {
            (function (window) {
                DEFINE([DEPENDENCY_NAMES], function (DEPENDENCY_ARGUMENTS) {
                    var args = arguments,
                        argNames = [DEPENDENCY_ARGUMENTS_LIST],
                        globals = [DECLARED_GLOBALS_LIST],
                        init = INIT_FUNCTION,
                        execute = function () {
                            MODULE_CODE();
                        };

                    // SETUP - add dependencies to the global namespace
                    argNames.forEach(function (prop, i) { window[prop] = args[i]; });

                    // EXECUTION - execute code in the context of the window
                    execute.call(window);

                    var exportValue = init.apply(window, args);

                    // CLEANUP - remove dependencies and exports from the global namespace
                    argNames.concat(globals).forEach(function (prop) {
                        try {
                            delete window[prop];
                        } catch (e) {
                            window[prop] = undefined;
                        }
                    });

                    return exportValue;
                });
            }(WINDOW));
        }
        // ReSharper restore UseOfImplicitGlobalInFunctionScope


        // get function text, removing outer function wrapper
        var moduleText = moduleDefinitionTemplate.toString().replace(/^[^{]*\{/, '').replace(/\}$/, '');

        // make string substitutions
        for (var pattern in substitutions) {
            if (substitutions.hasOwnProperty(pattern)) {
                var i = moduleText.indexOf(pattern);
                // can't use .replace() here or replacement patterns (e.g., $`, $', etc.) will eff everything up
                moduleText = moduleText.substring(0, i) + substitutions[pattern] + moduleText.substring(i + pattern.length);
            }
        }

        // lyleshearer 11/19/2013 - not sure if the IE concern is valid for our use, but keeping it in here proactively
        //IE with conditional comments on cannot handle the
        //sourceURL trick, so skip it if enabled.
        /*@if (@_jscript) @else @*/
        if (!isBuild) {
            moduleText += '\r\n//# sourceURL=' + fullModulePath;
        }
        /*@end@*/

        return moduleText;
    }

    //>>excludeEnd('excludeWrap')

    return {
        //>>excludeStart('excludeWrap', pragmas.excludeWrap)

        write: function (pluginName, moduleName, write, config) {
            // used during build for inlining dependencies; pre-defines templates as separate modules
            if (moduleName in contentMap) {
                var text = contentMap[moduleName];
                write.asModule(pluginName + '!' + moduleName, text);
            }
        },
        //>>excludeEnd('excludeWrap')

        load: function (modulePath, parentRequire, load, config) {

            //>>excludeStart('excludeWrap', pragmas.excludeWrap)
            var wrapConfig = getWrapConfig(config),
                modulePathToName = getModulePathToNameMap(config);

            var moduleName = modulePathToName[modulePath];
            if (!moduleName) {
                throw new Error('Cannot find module name for wrapped module with path "' + modulePath + '". Ensure the it is declared in the map.* section of the config.');
            }

            var moduleConfig = wrapConfig.configs[moduleName];
            if (!moduleConfig) {
                throw new Error('No wrap.config entry for module "' + moduleName + '"');
            }

            var depModuleToGlobalsMap = {};
            moduleConfig.deps.forEach(function (depModule) {
                var depConfig = wrapConfig.configs[depModule] || wrapConfig.pseudoConfigs[depModule];
                if (!depConfig) {
                    throw new Error('No wrap config found for dependent module "' + depModule + '" of "' + moduleName + '". ' +
                        'If it is a wrapped module, ensure the module names match. ' +
                        'If it is not wrapped, ensure there is an entry for "' + depModule + '" in the wrap.pseudoConfigs config section.');
                }
                // this can be null
                depModuleToGlobalsMap[depModule] = depConfig.exports[0];
            });

            var fullModulePath = parentRequire.toUrl(modulePath + '.js');

            fetchText(fullModulePath, function (moduleCode) {

                if (moduleConfig.pre) {
                    moduleCode = moduleConfig.pre + '\n' + moduleCode;
                }

                if (moduleConfig.post) {
                    moduleCode = moduleCode + '\n' + moduleConfig.post;
                }

                var moduleText = wrapModule(moduleCode, depModuleToGlobalsMap, moduleConfig.exports, moduleConfig.init, config.isBuild, fullModulePath);

                contentMap[modulePath] = moduleText;

                //                console.error('// wrapping module:', sourceModule);
                //                console.error('//------->\n' + moduleText + '\n//<-------');

                load.fromText(moduleText);
            });
            //>>excludeEnd('excludeWrap')
        }
    };
});
